import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Button2 from "../components/Button2";
import InputText2 from "../components/InputText2";
import { ReactComponent as PhotoIcon } from "../icons/photo.svg";
import { ReactComponent as SuccessIcon } from "../icons/success.svg";
import PDLList from "../components/PDLList";
import Dropdown from "../components/Dropdown";
import { adminServices } from "../services/AdminServices";
import AlertModal from "../components/AlertModal";
import { useParams } from "react-router-dom";
import LoadingModal from "../components/LoadingModal";
import InputText1 from "../components/InputText1";
import DataTable from "react-data-table-component";
import Button from "../components/Button";
import ServiceFormComponent from "../components/merchants/ServiceForm";
import { encryptSHA256, formatCurrency } from "../tools/tool";
import { validatePassword } from "../tools/passwordPolicy";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import DisabledModal from "../components/DisabledModal";
import ConfirmationDialog from "../components/ConfirmationDialog";
import { toast } from "react-toastify";
document.title = 'PDL Administration | Merchant Onboarding';
const MerchantPage_Edit = () => {
  const navigate = useNavigate();
  const {
    merchantId
  } = useParams();
  const [loading, setLoading] = useState(false);
  const [merchantInfo, setMerchantInfo] = useState({});
  const [merchantName, setMerchantName] = useState("");
  const [storeName, setStoreName] = useState("");
  const [location, setLocation] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedCat, setSelectedCat] = useState(0);
  const [services, setServices] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [display, setDisplay] = useState(false);
  const [serviceData, setServiceData] = useState(null);
  const [showServiceForm, setShowServiceForm] = useState(false);
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState("");
  const [passwd, setPasswd] = useState("");
  const [status, setStatus] = useState(null);
  const [quadrant, setQuadrant] = useState("");
  const [withSf, setWithSf] = useState(1); //1 yes 2 no
  const [storeCode, setStoreCode] = useState("");
  const [storeLocation, setStoreLocation] = useState("");
  const [colonies, setColonies] = useState([]);
  const [fee, setFee] = useState(0);
  const [facilities, setFacilities] = useState([]);

  // Confirmation Dialog
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  useEffect(() => {
    getServiceCategories();
    getColonies();
  }, []);
  useEffect(() => {
    getMerchantInfo();
  }, [merchantId]);
  useEffect(() => {
    if (merchantInfo) {
      if (merchantInfo.merchantType == "Services") {
        getServices();
      }
      getPOSUserData();
    }
  }, [merchantInfo]);
  const onCategoryChange = e => {
    if (e.target.value != 0 && e.target.value != merchantInfo.categoryId) {
      setDisplay(true);
    } else {
      setDisplay(false);
    }
    setSelectedCat(e.target.value);
  };
  const getServiceCategories = () => {
    adminServices.serviceCategories().then(r => {
      //console.log(r.data);
      let _opt = [];
      for (var i of r.data) {
        _opt.push({
          value: i.id,
          label: i.category
        });
      }
      setOptions(_opt);
    }).catch(e => {
      //console.log(e);
    });
  };
  const getColonies = async () => {
    try {
      await adminServices.storeProcedure2("getColonies", {}).then(response => {
        if (Array.isArray(response.data)) {
          const _opt = response.data.map(i => ({
            value: i.colony_id,
            label: i.colony_name,
            fac: JSON.parse(i.facilities)
          }));
          var defaultOption = {
            label: '--- Select Store Location ---',
            value: null
          };
          setColonies([defaultOption, ..._opt]);
        }
      }).catch(e => {});
    } catch (e) {
      //console.log(e);
    }
  };
  useEffect(() => {
    if (storeLocation) {
      let quad = quadrant;
      let fac = colonies.find(c => c.value == storeLocation)?.fac;
      // //console.log(fac);

      const defaultOption = {
        Facility: '---Select a facility/quadrant---',
        FacilityId: null
      };
      setFacilities([defaultOption, ...fac]);
      setQuadrant(quad);
    }
  }, [storeLocation]);
  const getMerchantInfo = async () => {
    setLoading(true);
    await adminServices.storeProcedure2("getMerchantInfo", {
      p_merchantId: merchantId
    }).then(response => {
      setMerchantInfo(response.data[0]);
      setMerchantName(response.data[0].merchantName);
      setStoreName(response.data[0].storeName);
      setLocation(response.data[0].location);
      setSelectedCat(response.data[0].categoryId);
      setStatus(response.data[0].status);
      setWithSf(response.data[0].with_sf);
      setStoreCode(response.data[0].merchantCode || "");
      setStoreLocation(response.data[0].storeLocation || "");
      setQuadrant(response.data[0].quadrant);
      setFee(response.data[0].merchantType == 'Services' ? response.data[0].kioskFee : response.data[0].merchantType == 'Store' ? response.data[0].posFee : 0);
      if (response.data.length == 0) {
        navigate('/merchant/add');
      }
    }).catch(error => {
      error.status == 401 ? navigate('/') : setAlertMessage("An error occurred while fetching merchant information. Please try again later.");
      setShowAlert(true);
    }).finally(() => {
      setLoading(false);
    });
  };
  const getPOSUserData = async () => {
    setLoading(true);
    await adminServices.storeProcedure2("getPOSAccount", {
      p_merchantId: merchantId
    }).then(response => {
      setUserName(response.data[0].username);
      setPasswd();
      setUserId(response.data[0].userID);
    }).catch(error => {}).finally(() => {
      setLoading(false);
    });
  };
  const getServices = async () => {
    setLoading(true);
    if (merchantInfo) {
      await adminServices.storeProcedure2("get_services_by_merchant_and_category_id", {
        vMerchantId: merchantId,
        vServiceCatId: merchantInfo.categoryId
      }).then(response => {
        setServices(response.data);
      }).catch(error => {}).finally(() => {
        setLoading(false);
      });
    }
  };
  const handleSave = () => {
    if (merchantName == "" || storeName == "" || location == "") {
      setShowAlert(true);
      setAlertMessage("Please fill all required fields. Merchant Name, Store Name, and Location are required.");
      return;
    }
    if (merchantInfo && merchantInfo.merchantType == "Store" && (storeLocation == null || storeLocation === "")) {
      setShowAlert(true);
      setAlertMessage("Please select Store Location.");
      return;
    }
    setLoading(true);
    const merchantNameParam = merchantName.replace(/'/g, "''");
    const storeNameParam = storeName.replace(/'/g, "''");
    const locationParam = location.replace(/'/g, "''");
    const storeCodeParam = storeCode ? `'${storeCode.replace(/'/g, "''")}'` : "null";
    const storeLocationParam = storeLocation ? storeLocation : "null";

    // extract userId from JWT (stored in appToken) to include as parameter
    let jwtUserId = "null";
    try {
      const token = localStorage.getItem('appToken');
      if (token) {
        const parts = token.split('.');
        if (parts.length >= 2) {
          const payload = JSON.parse(atob(parts[1]));
          // prefer the NameIdentifier claim when available (common keys and URIs)
          jwtUserId = payload.nameidentifier || payload.nameid || payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'] || payload.userId || payload.id || payload.sub || payload.user_id || payload.uid || "null";
          if (jwtUserId === undefined || jwtUserId === null) jwtUserId = "null";
        }
      }
    } catch (e) {
      jwtUserId = "null";
    }

    // ensure numeric values are not quoted; if jwtUserId is a string that contains non-digits, quote it
    const jwtParam = jwtUserId && /^\d+$/.test(jwtUserId.toString()) ? jwtUserId : jwtUserId === "null" ? "null" : `'${jwtUserId.toString().replace(/'/g, "''")}'`;
    adminServices.storeProcedure2("UpdateMerchantDetails", {
      merchantId: merchantId,
      merchantName: merchantNameParam,
      descr: storeNameParam,
      loc: locationParam,
      p_category_id: selectedCat,
      p_quadrant: quadrant,
      p_wsf: withSf,
      p_mCode: storeCodeParam,
      p_stLoc: storeLocationParam,
      p_user_id: jwtParam,
      p_user_agent: "Admin Booth",
      p_kFee: merchantInfo.merchantType == 'Services' ? fee : 0,
      p_pFee: merchantInfo.merchantType == 'Store' ? fee : 0
    }).then(response => {
      setLoading(false);
      setShowAlert(true);
      setAlertMessage("Merchant information has been updated successfully.");

      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);
    }).catch(error => {
      if (error.status == 401) {
        window.location.href = "/";
      }
      setAlertMessage(error.message);
      setShowAlert(true);
    }).finally(() => {
      setLoading(false);
    });
  };
  const handleRowClick = row => {
    if (row.service == "Generic Services" && row.unit == "service") {
      setShowAlert(true);
      setAlertMessage("Generic Service cannot be edited.");
      return;
    }
    let service = {
      "merchantId": merchantId,
      "categoryId": selectedCat,
      "serviceId": row.id,
      "serviceName": row.service,
      "price": row.price,
      "unit": row.unit,
      "status": row.status
    };
    setServiceData(service);
    setShowServiceForm(true);
  };
  const handleAfterSubmit = action => {
    setShowAlert(true);
    if (action == "delete") {
      setAlertMessage("Service has been deleted successfully.");
      toast.success("Service deleted successfully.");
      return;
    }
    if (action == "disabled") {
      setAlertMessage("Service cannot be deleted, but was set to disabled.");
      toast.warning("Service added successfully.");
      return;
    } else {
      setAlertMessage("Service has been saved successfully.");
      toast.success("Service added successfully.");
    }
  };
  const handleReset = async () => {
    if (userName == "" || passwd == "") {
      setShowAlert(true);
      setAlertMessage("Please fill all required fields. Username and Password are required.");
      return;
    }
    const passwordCheck = validatePassword(passwd);
    if (!passwordCheck.valid) {
      setShowAlert(true);
      setAlertMessage(passwordCheck.message);
      return;
    }
    let hashed = encryptSHA256(passwd);
    await adminServices.storeProcedure2("UpdatePostAccount", {
      p_id: userId,
      p_uname: userName,
      p_pass: hashed
    }).then(response => {
      if (response.data[0].message == "User successfully updated") {
        setAlertMessage("User successfully updated");
        setShowAlert(true);
      } else {
        setAlertMessage(response.data[0].message);
        setShowAlert(true);
      }
    }).catch(error => {
      if (error.status == 401) {
        window.location.href = "/";
      }
    }).finally(() => {
      setLoading(false);
    });
  };
  const handleEnable = async () => {
    setStatus(null);
    setLoading(true);
    await adminServices.storeProcedure2("setMerchantStatus", {
      statusId: 1,
      merchantId: merchantId
    }).then(response => {
      getMerchantInfo();
    }).catch(error => {
      if (error.status == 401) {
        window.location.href = "/";
      }
    }).finally(() => {
      setLoading(false);
    });
  };
  const handleDisable = async () => {
    setShowConfirmation(true);
    setConfirmationMessage("Are you sure you want to disable this merchant?");
  };
  return <div>
    <LoadingModal show={loading} message="Please wait" />
    <DisabledModal show={status == 0} onEnable={handleEnable} btnLabel={"Enable Merchant"} message={"Merchant (" + merchantName + ") is inactive. Please set to active first to edit data."} />
    <AlertModal show={showAlert} title={"Edit Merchant Data"} message={alertMessage} onClose={() => setShowAlert(false)} />
    
    
    {/* Confirmation Dialog For Disabling Merchant*/}
    <ConfirmationDialog show={showConfirmation} message={confirmationMessage} onCancel={() => setShowConfirmation(false)} onConfirm={async () => {
      setLoading(true);
      setShowConfirmation(false);
      await adminServices.storeProcedure2("setMerchantStatus", {
        statusId: 0,
        merchantId: merchantId
      }).then(response => {
        navigate("/merchant");
      }).catch(error => {
        if (error.status == 401) {
          window.location.href = "/";
        }
      }).finally(() => {
        setLoading(false);
      });
    }} />


    <ServiceFormComponent show={showServiceForm} onClose={() => {
      setShowServiceForm(false);
      getServices();
    }} data={serviceData} onAfterSubmit={handleAfterSubmit} onError={() => {
      setShowAlert(true);
      setAlertMessage("An error occurred while saving the service. Please try again later.");
      toast.error("An error occurred while saving the service. Please try again later.");
    }} />
    <div style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center'
    }}>
        Merchant Information
    </div>
    
    {/* PDL Information */}
    <div className="d-flex justify-content-start align-items-center mb-3">

      <div className="col-2 d-flex align-items-center justify-content-between">
        <div className="fw-bold">
          PDL Name
        </div>
        <div className="fw-italic">
          {merchantInfo && merchantInfo.pdlName}
        </div>
      </div>

      <div className="col-2"></div>

      <div className="col-2 d-flex align-items-center justify-content-between">
        <div className="fw-bold">
          PDL Number
        </div>
        <div className="fw-italic">
          {merchantInfo && merchantInfo.pdlNumber}
        </div>
      </div>

    </div>
    
    {/* Merchant Information */}
    <div className="d-flex justify-content-start align-items-center mb-3">

      <InputText1 title="Merchant Name" placeholder="Enter Merchant Name" name="merchantName" value={merchantName} onChange={e => setMerchantName(e.target.value)} />

    <InputText1 title="Store Name" placeholder="Enter Store Name" name="merchantName" value={storeName} onChange={e => setStoreName(e.target.value)} />

    <InputText1 title="Location" placeholder="Enter Location" name="location" value={location} onChange={e => setLocation(e.target.value)} />

    <InputText1 title="Store Code" placeholder="" name="storeCode" value={storeCode} readonly={true} onChange={e => setStoreCode(e.target.value)} />

    <div style={{
        minWidth: 220
      }}>
      <Dropdown title={"Store Location"} data={colonies} onChange={e => {
          setStoreLocation(e.target.value);
          if (e.target.value) {
            const seq = Date.now().toString().slice(-6);
            //setStoreCode(`STR-${e.target.value}-${seq}`);
            let fac = colonies.find(c => c.value == e.target.value)?.fac;
            // //console.log(fac);
            setFacilities(fac || []);
          } else {
            setStoreCode("");
          }
        }} value={storeLocation} />
    </div>

    {<div className="w-50">
        <InputText1 title={merchantInfo.merchantType == 'Services' ? "Kiosk Fee %" : merchantInfo.merchantType == 'Store' ? "POS Fee %" : "Fee %"} type="number" value={fee} onChange={e => setFee(e.target.value)} placeholder="Enter Fee" />
      </div>}

    </div>

    <div className="d-flex justify-content-start align-items-center mb-3">

      <div className="col-2">
        {<Dropdown title={"With Service Fee"} data={[{
          value: "1",
          label: "Yes"
        }, {
          value: "2",
          label: "No"
        }]} onChange={e => setWithSf(e.target.value)} value={withSf} />}
      </div>

      <div className="col-2 align-items-center justify-content-between">
      {merchantInfo.merchantType == "Services" && <Dropdown title={"Category"} data={options} className="r" onChange={onCategoryChange} value={selectedCat}>
            </Dropdown>}
          {merchantInfo.merchantType == "Services" && display && <span className="text-danger">All services will be updated under this category on Save.</span>}
      </div>
      <div className="col-2">
        {<Dropdown title={"Facility / Quadrant"} data={facilities.map(f => ({
          value: f.FacilityId,
          label: f.Facility
        }))} onChange={e => setQuadrant(e.target.value)} value={quadrant} />}
      </div>

      

      <div className="col d-flex align-items-center justify-content-end">
        <div className="btn-group">
            <Button size={"lg"} onClick={handleSave}>
              Save Merchant Info
            </Button>
            <Button size={"lg"} variant={"danger"} onClick={handleDisable}>
              Disable Merchant
            </Button>
        </div>
      </div>
    </div>

    {merchantInfo.merchantType == "Services" && <div className="card mb-3">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="col">
            Available Services
          </div>
          <Button size={"xs"} variant={"success"} onClick={() => {
          setServiceData({
            "merchantId": merchantId,
            "categoryId": selectedCat,
            "serviceName": "",
            "serviceId": null,
            "price": "",
            "unit": "",
            "status": 1
          });
          setShowServiceForm(true);
        }}> + </Button>
        </div>
        <div className="card-body">
          <DataTable columns={[{
          "name": "Service Name/Product Name",
          selector: row => row.service,
          sortable: true
        }, {
          "name": "Price",
          selector: row => formatCurrency(row.price),
          sortable: true,
          right: true
        }, {
          "name": "Unit",
          selector: row => row.unit,
          sortable: true
        }, {
          "name": "Date Added",
          selector: row => new Date(row.reg_date).toLocaleString(),
          sortable: true
        }, {
          "name": "Status",
          selector: row => row.status == 1 ? "Active" : "Inactive",
          sortable: true
        }]} data={services} onRowClicked={handleRowClick} pagination highlightOnHover pointerOnHover striped />
        </div>
    </div>}

    {merchantInfo.merchantType == "Store" && <div className="card mb-3">
      <div className="card-header d-flex justify-content-between align-items-center">
           <div className="col">
            POS User Data
          </div>
      </div>
      <div className="card-body">
      <InputText1 title="Username" placeholder="Enter Username" name="merchantName" value={userName} onChange={e => setUserName(e.target.value)} />
       <InputText1 title="Password" placeholder="Enter Password" name="merchantName" value={passwd} onChange={e => setPasswd(e.target.value)} type="password" />
      </div>
      <div className="card-footer d-flex justify-content-end align-items-center">
        <Button size={"lg"} variant={"success"} onClick={handleReset}>Update POS Account</Button>
      </div>
    </div>}

  </div>;
};
export default withAuthorization(MerchantPage_Edit, 15);